import { render } from "./SemStep1Scale.vue?vue&type=template&id=6bfbb472&scoped=true"
import script from "./SemStep1Scale.vue?vue&type=script&lang=js"
export * from "./SemStep1Scale.vue?vue&type=script&lang=js"

import "./SemStep1Scale.vue?vue&type=style&index=0&id=6bfbb472&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfbb472"]])

export default __exports__